import { UiColors } from "../../../../config/ui/colors";

export const COLLECTION_OF_WEEE_BY_EU_MEMBER_STATES_CHART_DATA_KEYS = [
	{
		name: "large",
		translation: "pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.chart.dataKeys.large",
		color: UiColors.charts.primary,
	},
	{
		name: "small",
		translation: "pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.chart.dataKeys.small",
		color: UiColors.charts.secondary,
	},
	{
		name: "other",
		translation: "pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.chart.dataKeys.other",
		color: UiColors.charts.grid,
	},
];